<template>
  <help-info-wrapper
    :service-name="serviceName"
    class="warp"
    :key="$i18n.locale + 'WS'"
  >
    <template>
      <v-card flat>
        <template v-if="rerender">
          <custom-popup
            id="gallery"
            v-model="dialog"
            :cons="{ title: $t('add_working_time') }"
            hide-confirm
            max-width="500"
          >
            <template v-slot:helpinfo>
              <help-info
                :element-name="`${serviceName}-${componentName}-title-gallery`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                :label="$t('add_working_time')"
              />
            </template>
            <v-card class="p-8">
              <div class="rowinfo">
                <v-select
                  v-model="selectedDay"
                  :items="computedDays"
                  dense
                  outlined
                  class="contentinfo"
                />
                <help-info
                  :element-name="`${serviceName}-${componentName}-selectedDay`"
                  :service-name="serviceName"
                  :help-data="helpData"
                  class="buttoninfo"
                  :label="$t('selected_day')"
                />
              </div>

              <v-card-subtitle class="d-flex align-items-center">
                <v-checkbox
                  v-model="ex4"
                  color="green lighten-3"
                  hide-details
                  dir="rtl"
                  style="margin: 0 !important; padding: 0"
                  class="chechbox"
                  :label="$t('footer.add_secondshift')"
                >
                </v-checkbox>
              </v-card-subtitle>

              <v-card-text v-if="selectedDay == 'dateToDate'">
                <custom-date-picker
                  v-model="dateTime.first"
                  :label="$t('footer.firstDate')"
                  outlined
                  input-class="date-end"
                  dense
                  append-icon="mdi-calendar-month"
                  format="date"
                  :sp="'/'"
                  :key="$i18n.locale + 'wef'"
                />
                <custom-date-picker
                  v-model="dateTime.second"
                  :label="$t('footer.endDate')"
                  outlined
                  dense
                  append-icon="mdi-calendar-month"
                  format="date"
                  :sp="'/'"
                  :key="$i18n.locale + 'wee'"
                />

                <v-text-field
                  v-model="dateSum"
                  :label="$t('range_name')"
                  outlined
                  dense
                />
              </v-card-text>

              <v-card-actions>
                <div class="rowinfo" style="width: 100% !important">
                  <v-btn
                    class="btn-sub ms-auto px-8 contentinfo"
                    color="green"
                    @click="addDay"
                    outlined
                  >
                    <v-icon>mdi-plus</v-icon>
                    {{ $t("add") }}
                  </v-btn>
                  <help-info
                    :element-name="`${serviceName}-${componentName}-addDay`"
                    :service-name="serviceName"
                    :help-data="helpData"
                    class="buttoninfo"
                    :label="$t('add')"
                  />
                </div>
              </v-card-actions>
            </v-card>
          </custom-popup>

          <template
            v-if="selectedDays.length && Object.keys(workSheet.items).length"
          >
            <v-row
              v-for="({ value, shift }, index) in computedDays.filter(
                (item) => !!item.disabled,
              )"
              :key="index"
              class="pa-2"
              no-gutters
            >
              <v-col cols="12">
                <v-btn icon @click="removeDay(value)">
                  <v-icon>mdi-delete</v-icon>
                </v-btn>

                <p
                  class="day text-dark my-auto"
                  :dir="$i18n.locale === 'en' ? 'ltr' : 'rtl'"
                >
                  {{ workSheet.items[value].name }}:
                </p>
              </v-col>

              <v-col class="pa-md-2" cols="12" :md="shift ? '6' : '12'">
                <p>{{ $t("first_shift") }}</p>
                <div class="rowinfo">
                  <timepicker
                    v-model="workSheet.items[value].shift[0].start"
                    :label="$t('start_time')"
                    class="contentinfo"
                  />
                  <help-info
                    v-if="index === 0"
                    :element-name="`${serviceName}-${componentName}-worksheet-shift-1-start`"
                    :service-name="serviceName"
                    :help-data="helpData"
                    class="buttoninfo"
                    :label="$t('start_time')"
                  />
                </div>
                <div class="rowinfo">
                  <timepicker
                    v-model="workSheet.items[value].shift[0].end"
                    :label="$t('end_time')"
                    class="contentinfo"
                  />
                  <help-info
                    v-if="index === 0"
                    :element-name="`${serviceName}-${componentName}-worksheet-shift-1-end`"
                    :service-name="serviceName"
                    :help-data="helpData"
                    class="buttoninfo"
                    :label="$t('end_time')"
                  />
                </div>
              </v-col>
              <v-col class="pa-md-2" cols="12" md="6" v-if="shift">
                <p>{{ $t("second_shift") }}</p>
                <div class="rowinfo">
                  <timepicker
                    v-model="workSheet.items[value].shift[1].start"
                    :label="$t('start_time')"
                    class="contentinfo"
                  />
                  <help-info
                    v-if="index === 0"
                    :element-name="`${serviceName}-${componentName}-worksheet-shift-2-start`"
                    :service-name="serviceName"
                    :help-data="helpData"
                    class="buttoninfo"
                    :label="$t('add_working_time')"
                  />
                </div>
                <div class="rowinfo">
                  <timepicker
                    class="contentinfo"
                    v-model="workSheet.items[value].shift[1].end"
                    :label="$t('end_time')"
                  />
                  <help-info
                    v-if="index === 0"
                    :element-name="`${serviceName}-${componentName}-worksheet-shift-2-end`"
                    :service-name="serviceName"
                    :help-data="helpData"
                    class="buttoninfo"
                    :label="$t('end_time')"
                  />
                </div>
              </v-col>
            </v-row>
          </template>

          <v-card-actions class="px-6 pt-6">
            <div class="rowinfo" style="width: 100% !important">
              <v-btn
                color="success"
                outlined
                @click="dialog = true"
                class="contentinfo"
              >
                <v-icon>mdi-plus</v-icon>
                {{ $t("add_working_time") }}
              </v-btn>
              <help-info
                :element-name="`${serviceName}-${componentName}-worksheet-add`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                :label="$t('add_working_time')"
              />
            </div>
          </v-card-actions>
        </template>
      </v-card>
    </template>
  </help-info-wrapper>
</template>

<script>
import moment from "moment-jalaali";
import CustomDatePicker from "@/view/content/custom-date-picker";
import Timepicker from "@/view/components/Timepicker";

export default {
  name: "WorkSheet",
  components: { Timepicker, CustomDatePicker },
  props: {
    value: Object,
  },
  data() {
    return {
      helpData: [],
      dateTime: { first: this.getTodayDate(), second: this.getTodayDate() },
      dateSum: "",
      serviceName: "Qrland",
      componentName: "work-sheet",
      dialog: false,
      rerender: true,
      ex4: false,
      selectedDays: [],
      selectedDay: undefined,
      days: [
        {
          value: "dateToDate",
          translationKey: "date_range",
          disabled: false,
          shift: false,
        },
        {
          value: "wholeWeek",
          translationKey: "all_week_days",
          disabled: false,
          shift: false,
        },
        {
          value: "satWnd",
          translationKey: "saturday_to_wednesday",
          disabled: false,
          shift: true,
        },
        {
          value: "satThr",
          translationKey: "saturday_to_thursday",
          disabled: false,
          shift: false,
        },
        {
          value: "workWeek",
          translationKey: "work_week",
          disabled: false,
          shift: false,
        },
        {
          value: "saturday",
          translationKey: "saturday",
          disabled: false,
          shift: false,
        },
        {
          value: "sunday",
          translationKey: "sunday",
          disabled: false,
          shift: false,
        },
        {
          value: "monday",
          translationKey: "monday",
          disabled: false,
          shift: false,
        },
        {
          value: "tuesday",
          translationKey: "tuesday",
          disabled: false,
          shift: false,
        },
        {
          value: "wednesday",
          translationKey: "wednesday",
          disabled: false,
          shift: false,
        },
        {
          value: "thursday",
          translationKey: "thursday",
          disabled: false,
          shift: false,
        },
        {
          value: "friday",
          translationKey: "friday",
          disabled: false,
          shift: false,
        },
      ],
    };
  },
  computed: {
    workSheet: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    computedDays() {
      return this.days.map((day) => ({
        value: day.value,
        text: this.$t(day.translationKey),
        disabled: day.disabled,
        shift: day.shift,
      }));
    },
  },
  watch: {
    "$i18n.locale": {
      handler() {
        this.$forceUpdate();
        this.updateDateSum(); // Update dateSum when locale changes
      },
      immediate: true,
      deep: true,
    },
    ex4: {
      deep: true,
      handler(value) {
        this.computedDays.forEach((day) => {
          if (day.value === this.selectedDay) {
            day.shift = value;
          }
        });
      },
    },
    "workSheet.items": {
      deep: true,
      handler(val) {
        if (val.dateToDate && val.dateToDate.name) {
          const [first, second] = val.dateToDate.name.split(
            ` ${this.$t("to")} `,
          );
          this.dateTime.first = first; //this.parsePersianDate(first);
          this.dateTime.second = second; //this.parsePersianDate(second);
          this.dateSum = val.dateToDate.name;
        }
      },
    },
    dateTime: {
      deep: true,
      handler() {
        this.updateDateSum();
      },
    },
  },
  mounted() {
    for (let day in this.value.items) {
      const shifts = this.value.items[day]?.shift || [
        { start: null, end: null },
        { start: null, end: null },
      ];
      const hasValidShift = shifts.some((item) => Object.keys(item).length);
      if (hasValidShift) {
        this.selectedDays.push(day);
        const dayItem = this.days.find((item) => item.value === day);
        if (dayItem) {
          dayItem.disabled = true;
          dayItem.shift = shifts[1]?.start?.length > 0;
        }
      }
    }
    this.updateDateSum();
  },
  methods: {
    addDay() {
      let ws = { ...this.workSheet.items };
      const shiftEx4 = this.ex4;
      this.ex4 = false;

      if (
        ["workWeek", "wholeWeek", "satWnd", "satThr", "dateToDate"].includes(
          this.selectedDay,
        )
      ) {
        ws = {};
      } else {
        delete ws.workWeek;
        delete ws.wholeWeek;
        delete ws.satWnd;
        delete ws.satThr;
        delete ws.dateToDate;
      }

      this.days.forEach((item) => {
        item.disabled = [
          "workWeek",
          "wholeWeek",
          "satWnd",
          "satThr",
          "dateToDate",
        ].includes(this.selectedDay)
          ? false
          : [
              "workWeek",
              "wholeWeek",
              "satWnd",
              "satThr",
              "dateToDate",
            ].includes(item.value)
          ? false
          : item.disabled;
      });

      const selectedDayItem = this.days.find(
        (item) => item.value === this.selectedDay,
      );
      if (selectedDayItem) {
        selectedDayItem.disabled = true;
        selectedDayItem.shift = shiftEx4;
      }

      this.selectedDays.push(this.selectedDay);

      this.days
        .filter((item) => item.disabled)
        .forEach((item) => {
          ws[item.value] = {
            name: this.$t(item.translationKey),
            shift: shiftEx4
              ? [
                  { start: "", end: "" },
                  { start: "", end: "" },
                ]
              : [{ start: "", end: "" }],
            start: "08:00",
            end: "22:00",
          };
        });

      if (this.selectedDay === "dateToDate") {
        ws.dateToDate.name = this.dateSum;
      }

      this.workSheet = { ...this.workSheet, items: ws };
      this.dialog = false;
      this.selectedDay = null;
    },
    updateDateSum() {
      if (this.dateTime.first && this.dateTime.second) {
        this.dateSum = `${this.use_lang(
          this.formatSingleDate(this.dateTime.first),
        )} ${this.$t("to")} ${this.use_lang(
          this.formatSingleDate(this.dateTime.second),
        )}`;
      }
    },
    formatSingleDate(date) {
      let parsedDate;
      if (
        this.$i18n.locale === "fa" &&
        moment(date, "jYYYY/jMM/jDD", true).isValid()
      ) {
        parsedDate = date;
      } else if (
        this.$i18n.locale === "ar" &&
        moment(date, "DD/MM/YYYY", true).isValid()
      ) {
        parsedDate = moment(date, "YYYY/MM/DD");
      } else if (
        this.$i18n.locale === "en" &&
        moment(date, "MM/DD/YYYY", true).isValid()
      ) {
        parsedDate = moment(date, "MM/DD/YYYY");
      }
      return moment(parsedDate).format("YYYY/MM/DD");
    },
    getFormattedDate(dateString) {
      const date = new Date(dateString);
      if (isNaN(date)) return this.$t("form.invalid_date");
      if (this.$i18n.locale === "fa") {
        return moment(date).format("jYYYY/jMM/jDD");
      } else if (this.$i18n.locale === "ar") {
        return moment(date).format("YYYY-MM-DD");
      } else {
        return moment(date).format("YYYY-MM-DD");
      }
    },
    parsePersianDate(persianDate) {
      if (!persianDate) return "";
      if (this.$i18n.locale === "fa") {
        const momentDate = moment(persianDate, "jYYYY/jMM/jDD");
        return momentDate.isValid() ? momentDate.format("YYYY-MM-DD") : "";
      } else if (this.$i18n.locale === "ar") {
        const momentDate = moment(persianDate, "YYYY-MM-DD");
        return momentDate.isValid() ? momentDate.format("YYYY-MM-DD") : "";
      } else {
        const momentDate = moment(persianDate, "YYYY-MM-DD");
        return momentDate.isValid() ? momentDate.format("YYYY-MM-DD") : "";
      }
    },
    getTodayDate() {
      const today = moment();
      if (this.$i18n.locale === "fa") {
        return today.format("jYYYY/jMM/jDD");
      } else if (this.$i18n.locale === "ar") {
        return today.format("DD/MM/YYYY");
      } else {
        return today.format("MM/DD/YYYY");
      }
    },
    removeDay(index) {
      this.selectedDays = this.selectedDays.filter((day) => day !== index);
      const dayItem = this.days.find((item) => item.value === index);
      if (dayItem) {
        dayItem.disabled = false;
        dayItem.shift = false;
      }
      const ws = { ...this.workSheet.items };
      delete ws[index];
      this.workSheet = { ...this.workSheet, items: ws };
    },
  },
};
</script>

<style scoped>
.day {
  font-weight: 900;
}
.chechbox .v-input__slot {
  margin: 0 !important;
}
.checkbox-dense-margin-top {
  margin-top: 0;
}
</style>
